export const AdminComplianceProfileReducer = (state = {}, action) => {
    if (action.type === 'GET_ADMIN_COMPLIANCE_DATA') {
      return {
        ...state,
        orgComplianceDetails: action.payload,
      };
    } else {
      return state;
    }
  };
  